import {
  NEW_CONVERSATION,
  NEW_MESSAGE,
  SET_ACTIVE_CONVERSATION,
  DISPOSE_CONVERSATION,
  UPDATE_CONVERSATION_META,
  INITIALIZE_CONVERSATIONS,
  SET_CLOSED_CONVERSATIONS,
  SET_CLOSED_CONVERSATION_MESSAGES,
  LOAD_OLD_CONVERSATIONS,
  TRANSFER_CONVERSATION,
  INITIALIZE_TRANSFERRED_CONVERSATIONS,
  SET_TRANSFERRED_CONVERSATION_MESSAGES,
  SET_DELIVERY_INFO_IN_MESSAGE,
  SET_SEEN_INFO_IN_MESSAGE,
  UPDATE_SUGGESTIONS_FOR_MESSAGE,
} from "actions/types";
import { createReducer } from "@reduxjs/toolkit";
import { ConversationStatus } from "constants/ChatListingConstants";

const initialState = {
  conversations: [],
  activeConversationId: null,
  activeConversationStatus: null,
  transferredConversations: [],
};
const handleNewConversations = (state, payload) => {
  const { conversations } = state;
  const newConversation = payload;
  const existingConversation = conversations.find(
    (c) => c.conversationId === newConversation.conversationId
  );
  if (!existingConversation) {
    state.conversations.push(newConversation);
  } else {
    return;
  }
};
const handleNewMessage = (state, payload) => {
  const newConversations = state.conversations;
  const newMessage = payload;
  const conversationIdOfMessage = newMessage.conversationId;
  const conversationToUpdate = newConversations.find(
    (c) => c.conversationId === conversationIdOfMessage
  );
  if (conversationToUpdate) {
    const existingMessage = conversationToUpdate.messages.find(
      (m) => m.messageId === newMessage.messageId
    );
    if (!existingMessage) {
      conversationToUpdate.messages.push(newMessage);
    }
  }
};

const disposeConversation = (state, conversation) => {
  const conversationsToUpdate = state.conversations;
  const indexOfConversationToDispose = conversationsToUpdate.findIndex(
    (c) => c.conversationId === conversation.conversationId
  );
  if (indexOfConversationToDispose !== -1) {
    conversationsToUpdate.splice(indexOfConversationToDispose, 1, conversation);
  }
};

const conversationReducer = createReducer(initialState, {
  [NEW_CONVERSATION]: (state, action) => {
    handleNewConversations(state, action.payload);
  },
  [LOAD_OLD_CONVERSATIONS]: (state, action) => {
    action.payload.forEach((oldConversation) => {
      const existingConversationIndex = state.conversations.findIndex(
        (c) => c.conversationId === oldConversation.conversationId
      );
      if (existingConversationIndex !== -1) {
        const existingConversation =
          state.conversations[existingConversationIndex];
        state.conversations[existingConversationIndex] = {
          ...existingConversation,
          conversationMeta: {
            ...existingConversation.conversationMeta,
            ...oldConversation.conversationMeta,
          },
          messages: oldConversation.messages,
          agentName: oldConversation.agentName,
          chatTransferDetails: oldConversation.chatTransferDetails,
        };
      } else state.conversations.push(oldConversation);
    });
  },
  [NEW_MESSAGE]: (state, action) => {
    handleNewMessage(state, action.payload);
  },
  [SET_ACTIVE_CONVERSATION]: (state, action) => {
    if (action.payload) {
      const { conversationId, status } = action.payload;
      state.activeConversationId = conversationId;
      state.activeConversationStatus = status;
    } else {
      state.activeConversationId = null;
      state.activeConversationStatus = null;
    }
  },
  [DISPOSE_CONVERSATION]: (state, action) => {
    disposeConversation(state, action.payload);
  },
  [UPDATE_CONVERSATION_META]: (state, action) => {
    const { conversations } = state;
    const conversationIdToUpdate = action.payload.conversationId;
    const conversationToUpdate = conversations.find(
      (c) => c.conversationId === conversationIdToUpdate
    );
    if (conversationToUpdate) {
      conversationToUpdate.conversationMeta = action.payload.conversationMeta;
    }
  },
  [INITIALIZE_CONVERSATIONS]: (state, action) => {
    state.conversations = action.payload;
  },
  [SET_CLOSED_CONVERSATIONS]: (state, action) => {
    const closedConversations = state.conversations.filter(
      (con) => con.status === ConversationStatus.CLOSED
    );
    for (let closedConversation of action.payload) {
      const existingClosedConversationIndex = closedConversations.findIndex(
        (c) => c.conversationId === closedConversation.conversationId
      );
      if (existingClosedConversationIndex === -1) {
        state.conversations.push(closedConversation);
      } else {
        const existingClosedConversation =
          closedConversations[existingClosedConversationIndex];
        const updatedClosedConversation = {
          ...closedConversation,
          messages: existingClosedConversation.messages,
          agentName: existingClosedConversation.agentName,
        };
        state.conversations.splice(
          existingClosedConversationIndex,
          1,
          updatedClosedConversation
        );
      }
    }
  },

  [SET_CLOSED_CONVERSATION_MESSAGES]: (state, action) => {
    const { conversationId, messages } = action.payload;
    const closedConversation = state.conversations.find(
      (con) => con.conversationId === conversationId
    );
    closedConversation.messages = messages;
  },

  [TRANSFER_CONVERSATION]: (state, action) => {
    //Removing the existing entry of same conversation id and pushing the new one
    const indexOfSameConvId = state.transferredConversations.findIndex(
      (con) => con.conversationId === action.payload.conversationId
    );
    if (indexOfSameConvId !== -1) {
      state.transferredConversations.splice(indexOfSameConvId, 1);
    }
    state.transferredConversations.push(action.payload);

    // Removing the transferred conversation from the conversations
    const indexOfTransferredConversation = state.conversations.findIndex(
      (con) => con.conversationId === action.payload.conversationId
    );
    if (indexOfTransferredConversation !== -1) {
      state.conversations.splice(indexOfTransferredConversation, 1);
    }
  },

  [INITIALIZE_TRANSFERRED_CONVERSATIONS]: (state, action) => {
    state.transferredConversations = action.payload;
  },

  [SET_TRANSFERRED_CONVERSATION_MESSAGES]: (state, action) => {
    const { conversationId, messages } = action.payload;
    const conversationToUpdate = state.transferredConversations.find(
      (c) => c.conversationId === conversationId
    );
    if (conversationToUpdate) {
      conversationToUpdate.messages = messages;
    }
  },

  [SET_DELIVERY_INFO_IN_MESSAGE]: (state, action) => {
    const messageWithDeliveryInfo = action.payload;
    let conversationToUpdate = state.conversations.find(
      (c) => c.conversationId === messageWithDeliveryInfo.conversationId
    );
    if (conversationToUpdate) {
      let messageToUpdate = conversationToUpdate.messages.find(
        (msg) => msg.messageId === messageWithDeliveryInfo.messageId
      );
      if (messageToUpdate) {
        messageToUpdate.deliveredAt = messageWithDeliveryInfo.deliveredAt;
      }
    }
  },

  [SET_SEEN_INFO_IN_MESSAGE]: (state, action) => {
    const messageWithSeenInfo = action.payload;
    let conversationToUpdate = state.conversations.find(
      (c) => c.conversationId === messageWithSeenInfo.conversationId
    );
    if (conversationToUpdate) {
      let messageToUpdate = conversationToUpdate.messages.find(
        (msg) => msg.messageId === messageWithSeenInfo.messageId
      );
      if (messageToUpdate) {
        messageToUpdate.seenAt = messageWithSeenInfo.seenAt;
      }
    }
  },

  [UPDATE_SUGGESTIONS_FOR_MESSAGE]: (state, action) => {
    const messageWithSuggestions = action.payload;
    let conversationToUpdate = state.conversations.find(
      (c) => c.conversationId === messageWithSuggestions.conversationId
    );
    if (conversationToUpdate) {
      let messageToUpdate = conversationToUpdate.messages.find(
        (msg) => msg.messageId === messageWithSuggestions.messageId
      );
      if (messageToUpdate) {
        messageToUpdate.suggestions = messageWithSuggestions.suggestions;
      }
    }
  },
});

export default conversationReducer;
